export default `
  accessToken
  cycleUuid
  tenantUuid
`
